module.exports = __webpack_public_path__ + "img/39.8e6ec702.jpg";